import { Plan } from '~/src/common/brooklyn/plan-utils/Plan';
import { skus } from '~/src/common/brooklyn/plans';
import { useMonthlyPlanDetails } from '~/src/common/brooklyn/useMonthlyPlanDetails';
import { usePlanDetailsBySku } from '~/src/common/membership/usePlanDetailsBySku';
import { Price } from '~/src/common/price';
import { useAccessTier } from '~/src/common/subscription';

function formatPrice({ currencySymbol, price }: { price: number; currencySymbol: string }) {
  return `${currencySymbol}${Math.floor(price)}`;
}

function useMembershipSaleDetails() {
  const { plan: monthlyPlanDetails } = useMonthlyPlanDetails();
  const { plan: annualPlanDetails } = usePlanDetailsBySku(skus.annualWinback129);

  const annualByMonthPlan = monthlyPlanDetails ? new Plan(monthlyPlanDetails) : null;
  const annualPlan = annualPlanDetails ? new Plan(annualPlanDetails) : null;

  const annualPlanByMonthPrice = annualByMonthPlan ? annualByMonthPlan.annualPrice() : null;
  const annualPlanPrice = annualPlan ? annualPlan.annualPrice() : null;

  const currencySymbol = annualByMonthPlan?.currencySymbol() ?? '';
  const currencyIso = annualByMonthPlan?.currencyIso() ?? '';

  const isCurrencyISORequired =
    currencySymbol && currencyIso
      ? Price.isCurrencyISORequired({
          currencySymbol,
          currencyIso,
        })
      : false;

  return {
    url: '/create-account/2025-annual-spring-sale/',
    regularPrice: annualPlanByMonthPrice
      ? formatPrice({ price: annualPlanByMonthPrice, currencySymbol })
      : null,
    discountPrice: annualPlanPrice ? formatPrice({ price: annualPlanPrice, currencySymbol }) : null,
    currencyIso,
    isCurrencyISORequired,
  };
}

export function useAnnualSaleDetails() {
  const { hasMembershipAccess, loading } = useAccessTier();

  const membershipSaleDetails = useMembershipSaleDetails();

  return {
    loading,
    details: membershipSaleDetails,
    hasMembershipAccess,
  };
}
